<template>
  <div>
    <div class="w-full px-8 mb-8">
      <div class="bg-white overflow-hidden shadow rounded-lg my-5">
        <div class="grid grid-cols-2 sm:grid-cols-6 gap-4 px-5 pb-8">
          <div class="font-bold col-span-6 text-center">Your Order</div>
          <div
            style="position: relative"
            v-for="photo in photos"
            :key="photo.id"
          >
            <font-awesome-icon
              v-if="photo.can_remove"
              @click="handleRemovePhoto(photo.id)"
              icon="times-circle"
              class="fa-fw nav-icon fa-2x remove-button"
            ></font-awesome-icon>

            <img
              :src="getS3Photo(photo.path, photo.file_name, 250, 250, 40, true)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-xl mx-auto px-8 mobile-margin">
      <div
        class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 my-5"
      >
        <div class="px-4 py-5 grid grid-cols-2 gap-4 text-black">
          <div class="font-bold col-span-2 text-center">Your Shopping Cart</div>
          <div class="col-span-2">
            <base-button-primary @click="handleBack"
              >Back To Photos</base-button-primary
            >
            <base-button-white v-if="isExternal" @click="showDiscount" class="float-right">
              Apply Discount
            </base-button-white>
            <base-button-white @click="clearCart" class="float-right">
              Clear Cart
            </base-button-white>
          </div>
          <div class="col-span-2"><hr /></div>

          <div>
            {{ order.photoCount == 1 ? "Photo" : "Photos" }}
          </div>
          <div class="text-right">
            {{ order.photoCount }}
          </div>
          <div>
            {{ order.displayGroupCount == 1 ? "Photo Group" : "Photo Groups" }}
          </div>
          <div class="text-right">
            {{ order.displayGroupCount }}
          </div>
          <div class="col-span-2"><hr /></div>
          <div>Subtotal</div>
          <div class="text-right">
            {{
              ((order.subtotal + order.discount_value + order.discount24) / 100)
                | numberFormat("0.00")
            }}
          </div>
          <div v-if="order.processingFee">Processing Fee</div>
          <div v-if="order.processingFee" class="text-right">
            {{ (order.processingFee / 100) | numberFormat("0.00") }}
          </div>
          <div v-if="order.riverFee">River Fee</div>
          <div v-if="order.riverFee" class="text-right">
            {{ (order.riverFee / 100) | numberFormat("0.00") }}
          </div>
          <div v-if="order.riverSectionFee">River Section Fee</div>
          <div v-if="order.riverSectionFee" class="text-right">
            {{ (order.riverSectionFee / 100) | numberFormat("0.00") }}
          </div>
          <div v-if="order.tax">Taxes</div>
          <div v-if="order.tax" class="text-right">
            {{ (order.tax / 100) | numberFormat("0.00") }}
          </div>
          <div v-if="order.discount24">24hr Discount</div>
          <div v-if="order.discount24" class="text-right">
            -{{ (order.discount24 / 100) | numberFormat("0.00") }}
          </div>

          <div v-if="order.discount">Discount {{ order.discount.name }}</div>
          <div v-if="order.discount_value" class="text-right">
            -{{ (order.discount_value / 100) | numberFormat("0.00") }}
          </div>

          <div class="col-span-2"><hr /></div>
          <div>Order Total</div>
          <div class="text-right">
            {{ (order.total / 100) | numberFormat("0.00") }}
          </div>

          <div class="col-span-2"><hr /></div>

          <div v-if="!understand" class="col-span-2">
            <input @click="understand = true" type="checkbox" />
            I understand that this purchase is for digital goods to be delivered
            electronically.
          </div>

          <div v-if="!understand" class="col-span-2"><hr /></div>

          <div
            v-show="
              understand && outfitter.allow_checkout_at_counter && !isExternal
            "
          >
            <base-button-primary @click="initiateCheckoutAtCounter"
              >Check out at counter</base-button-primary
            >
          </div>
          <div
            v-show="
              understand &&
              (!outfitter.require_checkout_at_counter || isExternal)
            "
          >
            <base-button-primary @click="initiateCheckoutCreditCard"
              >Check out with credit card</base-button-primary
            >
          </div>
        </div>
      </div>

      <div
        v-if="checkoutType == 'counter'"
        class="grid grid-cols-2 gap-4 bg-white overflow-hidden shadow rounded-lg px-4 py-5"
      >
        <div class="col-span-2">
          Please note that the above total does not include taxes or use fees.
          Taxes and use fees will be calculated at the register.
        </div>
        <div>
          <base-label>Your Name</base-label>
          <base-input v-model="counterData.name"></base-input>
        </div>
        <div>
          <base-label>Your Email</base-label>
          <base-input v-model="counterData.email"></base-input>
        </div>
        <div>
          <base-button-success @click="handleProceedToCounter"
            >Proceed To Counter</base-button-success
          >
        </div>
      </div>
      <div
        v-show="checkoutType == 'creditCard'"
        class="grid grid-cols-2 gap-4 bg-white overflow-hidden shadow rounded-lg px-4 py-5"
      >
        <div>
          <base-label>Name</base-label>
          <base-input v-model="charge.name"></base-input>
        </div>
        <div>
          <base-label>Email</base-label>
          <base-input v-model="charge.email"></base-input>
        </div>
        <div>
          <base-label>Country</base-label>
          <el-select
            v-model="charge.country"
            placeholder="Select"
            class="w-full"
          >
            <el-option
              v-for="country in countries"
              :key="country.value"
              :label="country.label"
              :value="country.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <base-label>State</base-label>
          <el-select v-model="charge.state" placeholder="Select" class="w-full">
            <el-option
              v-for="state in states"
              :key="state.value"
              :label="state.label"
              :value="state.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <base-label> Postal Code </base-label>
          <base-input v-model="charge.zip" />
        </div>
        <div>
          <base-button-primary @click="taxCalc" class="mt-5"
            >Proceed</base-button-primary
          >
        </div>
        <div v-show="showCreditCard" class="col-span-2">
          <credit-card
            :show-payment-form="showCreditCard"
            :id="4"
            @charge="handleCharge"
          ></credit-card>
        </div>
      </div>

      <base-modal
        :show="showDiscountModal"
        @close="showDiscountModal = false"
        @save="applyDiscount"
      >
        <template v-slot:header> Discount Code </template>
        <template v-slot:main>
          <div>
            <base-label>Code</base-label>
            <base-input v-model="discountCode" />
          </div>
        </template>
      </base-modal>

      <base-modal
        :show="showZeroBalance"
        @close="showZeroBalance = false"
        @save="processZeroBalance"
      >
        <template v-slot:header> Zero Balance </template>
        <template v-slot:main>
          <div class="grid grid-cols-2 gap-4">
            <div class="col-span-2">
              We notice that you have a zero balance on your order. Please enter
              your information and we will finish processing your order.
            </div>
            <div>
              <base-label>Your Name</base-label>
              <base-input v-model="zeroBalanceData.name"></base-input>
            </div>
            <div>
              <base-label>Your Email</base-label>
              <base-input v-model="zeroBalanceData.email"></base-input>
            </div>
            <div>
              <base-label>Country</base-label>
              <el-select
                v-model="zeroBalanceData.country"
                placeholder="Select"
                class="w-full"
              >
                <el-option
                  v-for="country in countries"
                  :key="country.value"
                  :label="country.label"
                  :value="country.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <base-label>State</base-label>
              <el-select v-model="zeroBalanceData.state" placeholder="Select" class="w-full">
                <el-option
                  v-for="state in zeroBalanceStates"
                  :key="state.value"
                  :label="state.label"
                  :value="state.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <base-label>Postal Code</base-label>
              <base-input v-model="zeroBalanceData.zip"></base-input>
            </div>
          </div>
        </template>
      </base-modal>

      <base-modal
        :show="showTimerModal"
        @save="startTimer"
        @close="finishTimer"
        save-text="I'm still working"
        cancel-text="Clear my cart"
      >
        <template v-slot:header> Timeout </template>
        <template v-slot:main>
          <div>
            Are you still working on this order? If not, we will clear your cart
            in 30 seconds.
          </div>
        </template>
      </base-modal>
    </div>
  </div>
</template>

<script>
import BaseButtonPrimary from "@/components/ui/buttons/BaseButtonPrimary";
import BaseLabel from "@/components/ui/forms/BaseLabel";
import BaseInput from "@/components/ui/forms/BaseInput";
import CreditCard from "@/components/cart/CreditCard";
import BaseButtonSuccess from "@/components/ui/buttons/BaseButtonSuccess";
import BaseButtonWhite from "@/components/ui/buttons/BaseButtonWhite";
import BaseModal from "@/components/ui/elements/BaseModal";
import photo from "../../mixins/photo";
import email from "../../mixins/email";
export default {
  name: "Cart",
  components: {
    BaseModal,
    BaseButtonWhite,
    BaseButtonSuccess,
    BaseInput,
    BaseLabel,
    BaseButtonPrimary,
    CreditCard,
  },
  mixins: [photo, email],
  data() {
    return {
      showTimerModal: false,
      timer: null,
      date: null,
      checkoutType: null,
      counterData: {
        name: null,
        email: null,
      },
      zeroBalanceData: {
        name: null,
        email: null,
        country: "US",
        state: null,
        zip: null,
      },
      charge: {
        name: null,
        email: null,
        country: "US",
        state: null,
        zip: null,
      },
      discountCode: null,
      showDiscountModal: false,
      showZeroBalance: false,
      showCreditCard: false,
      countries: [
        { label: "United States", value: "US" },
        { label: "Canada", value: "CA" },
        { label: "Other", value: "OT" },
      ],
      processing: false,
      understand: false,
    };
  },
  methods: {
    handleRemovePhoto(id) {
      if (
        confirm("Are you sure you want to remove this photo from your cart?")
      ) {
        const data = {
          order_id: this.order.id,
          photo_id: id,
        };
        this.$notify({
          title: "Cart",
          message: "Removing photo from cart",
          type: "success",
          position: "top-left",
        });
        this.$store.dispatch("order/remove", data).then((resp) => {
          if (!resp.success) return;

          this.$notify({
            title: "Cart",
            message: "The photo has been removed from your cart",
            type: "success",
            position: "top-left",
          });
        });
      }
    },
    taxCalc() {
      if (!this.charge.name || !this.charge.name.length) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter your name",
        });
        return;
      }
      if (!this.charge.email || !this.charge.email.length) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter your email",
        });
        return;
      }
      if (!this.isValidEmail(this.charge.email)) {
        this.$notify({
          title: "Invalid Data",
          type: "warning",
          message: "Please enter a valid email address",
        });
        return;
      }
      if (!this.charge.country || !this.charge.country.length) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please select a country",
        });
        return;
      }
      if (this.charge.country == "US" || this.charge.country == "CA") {
        if (!this.charge.state || !this.charge.state.length) {
          this.$notify({
            title: "Missing Data",
            type: "warning",
            message: "Please select a state",
          });
          return;
        }
        if (!this.charge.zip || !this.charge.zip.length) {
          this.$notify({
            title: "Missing Data",
            type: "warning",
            message: "Please enter your postal code",
          });
          return;
        }
      }
      const data = {
        orderId: this.order.id,
        name: this.charge.name,
        email: this.charge.email,
        country: this.charge.country,
        state: this.charge.state,
        zip: this.charge.zip,
      };
      this.$store.dispatch("order/calculate_tax", data).then((resp) => {
        if (resp.success) {
          this.showCreditCard = true;
        } else {
          this.$notify({
            title: "Miss-match Data",
            type: "warning",
            message:
              "We are unable to calculate taxes for this location. Please check the state and zip code",
          });
        }
      });
    },
    processZeroBalance() {
      if (!this.zeroBalanceData.name || !this.zeroBalanceData.email) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter your name and email address",
        });
        return;
      }
      if (!this.isValidEmail(this.zeroBalanceData.email)) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter a valid email address",
        });
        return;
      }
      if (!this.zeroBalanceData.country) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please select a country",
        });
        return;
      }
      if (
        (this.zeroBalanceData.country == "US" ||
          this.zeroBalanceData.country == "CA") &&
        (!this.zeroBalanceData.state || !this.zeroBalanceData.zip)
      ) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter your state and postal code",
        });
        return;
      }
      let data = this.zeroBalanceData;
      data.orderId = this.order.id;
      this.$store.dispatch("order/zero_balance", data).then((resp) => {
        if (!resp.success) return;

        this.$store.dispatch("order/clear_order");
        this.$store.dispatch("search/clear_displayGroups");
        this.clearTimer();
        this.$router.push(
          "/deliver/" + this.outfitter.slug + "/order/" + resp.order.hash
        );
      });
    },
    handleZeroBalance() {
      this.showZeroBalance = true;
    },
    applyDiscount() {
      const data = {
        code: this.discountCode,
        orderId: this.order.id,
      };
      this.$store.dispatch("order/apply_discount", data).then((resp) => {
        if (!resp.success) {
          this.$notify({
            title: "Discount Code",
            type: "warning",
            message: "Invalid Code",
          });
          this.showDiscountModal = false;
          return;
        }
        this.$store.dispatch("order/reload_order");
        this.$notify({
          title: "Discount Code",
          type: "success",
          message: "We have applied this discount code to your order",
        });
        this.discountCode = null;
        this.showDiscountModal = false;
      });
    },
    showDiscount() {
      this.discountCode = null;
      this.showDiscountModal = true;
    },
    clearCart() {
      if (confirm("Are you sure you want to clear the cart?")) {
        this.$store.dispatch("order/clear_order").then(() => {
          this.$store.dispatch("search/clear_displayGroups").then(() => {
            this.clearTimer();
            this.$router.go(-1);
          });
        });
      }
    },
    handleBack() {
      this.clearTimer();
      this.$router.go(-1);
    },
    handleCharge(nonce) {
      if (this.processing) return;

      if (!this.charge.name || !this.charge.email) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter your name and email address",
        });
        return;
      }

      if (!this.isValidEmail(this.charge.email)) {
        this.$notify({
          title: "Invalid Data",
          type: "warning",
          message: "Please enter a valid email address",
        });
        return;
      }

      this.processing = true;
      this.$notify({
        title: "Processing...",
        type: "success",
        message: "We are processing your payment. Please stand by",
      });
      const data = {
        nonce,
        orderId: this.order.id,
        name: this.charge.name,
        email: this.charge.email,
        country: this.charge.country,
        state: this.charge.state,
        zip: this.charge.zip,
        isExternal: this.isExternal,
      };
      this.$store.dispatch("order/charge", data).then((resp) => {
        this.processing = false;
        if (!resp.success) {
          this.$notify({
            title: "Failure",
            type: "warning",
            message: "We are unable to charge this credit card",
          });
          return;
        }

        this.$store.dispatch("order/clear_order");
        this.$store.dispatch("search/clear_displayGroups");
        this.clearTimer();
        let route =
          "/deliver/" + this.outfitter.slug + "/order/" + resp.order.hash;
        if (this.isExternal) {
          route += "/1";
        }
        this.$router.push(route);
      });
    },
    handleProceedToCounter() {
      if (this.processing) return;

      if (!this.counterData.name || !this.counterData.email) {
        this.$notify({
          title: "Missing Data",
          type: "warning",
          message: "Please enter your name and email address",
        });
        return;
      }

      if (!this.isValidEmail(this.counterData.email)) {
        this.$notify({
          title: "Invalid Data",
          type: "warning",
          message: "Please enter a valid email address",
        });
        return;
      }
      this.processing = true;

      this.$notify({
        title: "Processing",
        type: "success",
        message: "Stand by, processing....",
        duration: 8000,
      });
      let data = this.counterData;
      data.orderId = this.order.id;
      this.$store.dispatch("order/counter", data).then((resp) => {
        this.processing = false;
        if (!resp.success) {
          this.$notify({
            title: "Processing",
            type: "danger",
            message: "We've encountered an error in processing this order",
            duration: 0,
          });

          return;
        }
        this.clearTimer();
        this.$store.dispatch("order/clear_order");
        this.$store.dispatch("search/clear_displayGroups");
        this.$router.push("/deliver/" + this.outfitter.slug + "/counter");
      });
    },
    initiateCheckoutAtCounter() {
      this.checkoutType = "counter";
      this.$store
        .dispatch("order/set_counter", { orderId: this.order.id })
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch("order/load_order");
        });
    },
    initiateCheckoutCreditCard() {
      this.checkoutType = "creditCard";

      this.$store
        .dispatch("order/unset_counter", { orderId: this.order.id })
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch("order/load_order");
        });
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    startTimer() {
      this.clearTimer();
      this.showTimerModal = false;
      if (this.outfitter && this.outfitter.cart_timeout) {
        this.timer = setTimeout(
          this.showTimer,
          this.outfitter.cart_timeout * 1000
        );
      } else {
        this.timer = setTimeout(this.showTimer, 180000);
      }
    },
    showTimer() {
      this.showTimerModal = true;
      this.timer = setTimeout(this.finishTimer, 30000);
    },
    finishTimer() {
      this.showTimerModal = false;
      this.$store.dispatch("order/clear_order").then(() => {
        this.$store.dispatch("search/clear_displayGroups").then(() => {
          this.clearTimer();
          this.$router.go(-1);
        });
      });
    },
  },
  watch: {
    outfitter: function () {
      this.startTimer();
    },
  },
  computed: {
    isExternal: function () {
      return this.$store.getters["search/isExternal"];
    },
    outfitter: function () {
      return this.$store.getters["search/getOutfitter"];
    },
    order: function () {
      const order = this.$store.getters["order/getOrder"];
      if (order.order_items.length && !order.total) {
        this.handleZeroBalance();
      }
      return order;
    },
    photos: function () {
      let photos = [];
      this.order.order_items.forEach((order_item) => {
        if (order_item.photo) {
          let photo = order_item.photo;
          photo.can_remove = 1;
          photos.push(photo);
        } else if (order_item.display_group) {
          order_item.display_group.photos.forEach((photo) => {
            photo.can_remove = 0;
            photos.push(photo);
          });
        }
      });
      return photos;
    },
    states: function () {
      let returnArray = [];
      const states = this.$store.getters["order/getStates"];
      states.forEach((state) => {
        if (this.charge.country) {
          if (this.charge.country == state.country) {
            returnArray.push({ label: state.name, value: state.abbreviation });
          }
        } else {
          returnArray.push({ label: state.name, value: state.abbreviation });
        }
      });
      return returnArray;
    },
    zeroBalanceStates: function () {
      let returnArray = [];
      const states = this.$store.getters["order/getStates"];
      states.forEach((state) => {
        if (this.zeroBalanceData.country) {
          if (this.zeroBalanceData.country == state.country) {
            returnArray.push({ label: state.name, value: state.abbreviation });
          }
        } else {
          returnArray.push({ label: state.name, value: state.abbreviation });
        }
      });
      return returnArray;
    },
  },
  mounted() {
    this.$store.dispatch("order/load_order");
    this.$store.dispatch("order/get_states");
  },
};
</script>

<style scoped>
.remove-button {
  z-index: 10;
  position: absolute;
  top: 2px;
  right: 0px;
  color: #fa6b6b;
  cursor: pointer;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .mobile-margin {
    margin-bottom: 500px;
  }
}
</style>
